import request from './request'
import { PAY_GO_URL, PAY_QUERY_URL } from './config'

/**
 * 发起支付（/api/pay/go）
 * @param {Object} payload - 支付参数（商品信息、支付方式等）
 * @returns {Promise<{ path?: string, type?: string, orderNo?: string }>} 成功时返回 data（含 path、type、orderNo 等），token 与错误由 request 统一处理
 */
export async function goPay (payload) {
  const data = await request.post(PAY_GO_URL, payload || {})
  if (data && data.path && (data.type === 'ali' || data.type === 'alipay')) {
    setTimeout(() => {
      window.open(data.path, '_blank', 'noopener,noreferrer')
    }, 500)
  }
  return data
}

/**
 * 查询支付宝支付结果（/api/pay/query）
 * @param {string} orderNo - 支付单号（由 goPay 返回后传入）
 * @param {string} payType - 支付类型（由 goPay 返回后传入）
 * @returns {Promise<Object>} 成功时返回 data，用于判断是否已支付成功
 */
export function queryPayStatus (orderNo, payType) {
  return request.post(PAY_QUERY_URL, { orderNo: orderNo || '', payType: payType || '' })
}
